enum MobileDisplayState {
  chosenSims = 'chosenSims',
  simSettings = 'simSettings',
}

export { MobileDisplayState };
